import React from 'react';

const Tab = ({ children, onClick, className }) => {
  return (
    <div onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default Tab;
